'use client'
import {
  SuccessfullyReservedMeetingReservation as MeetingAttemptSuccessfullyReserved,
  MeetingReservation,
} from '@chilipiper/api-client/src/user-availability'

const CHILI_RESERVATION_STATUS = 'chili/RESERVATION_STATUS'
const CHILI_SLOT_RESERVATION = 'chili/SLOT_RESERVATION'

export const setMeetingAttemptReservation = (reservation: MeetingAttemptSuccessfullyReserved) => {
  localStorage.setItem(CHILI_RESERVATION_STATUS, JSON.stringify(reservation))
}

export const getMeetingAttemptReservation = (): MeetingAttemptSuccessfullyReserved | undefined => {
  const reservationStatus = localStorage.getItem(CHILI_RESERVATION_STATUS)
  return reservationStatus ? JSON.parse(reservationStatus) : undefined
}

export const setSlotReservation = (reservation: MeetingReservation) => {
  localStorage.setItem(CHILI_SLOT_RESERVATION, JSON.stringify(reservation))
}

export const deleteSlotReservation = () => {
  localStorage.removeItem(CHILI_SLOT_RESERVATION)
}

export const getSlotReservation = (): MeetingReservation | undefined => {
  const slotReservation = localStorage.getItem(CHILI_SLOT_RESERVATION)
  return slotReservation ? JSON.parse(slotReservation) : undefined
}

export const cleanSessionStorage = () => {
  Object.keys(localStorage)
    .filter(function (k) {
      return /chili/.test(k)
    })
    .forEach(function (k) {
      localStorage.removeItem(k)
    })
}
